import { Map } from 'mapbox-gl';

function getFeatureForPoint(
    map: Map,
    layerIds: string[],
    point: mapboxgl.Point
) {
    const features = map.queryRenderedFeatures(point, {
        layers: layerIds
    });
    return features.length ? features[0] : null;
}

export default getFeatureForPoint;
